import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/(callback-with-footer)/terms-and-conditions/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/GlobalStyles.tsx");
